import productosService from './productos.service';
import stockSucursalService from './stock-sucursal.service';

/**
 * Activa un producto importado desde master_catalog: precio + stock opcional.
 */
export async function activarProductoMaster({
  productoId,
  precioVenta,
  sucursalId,
  orgId,
  cargarStock,
  cantidadStock
}) {
  const precio = parseFloat(precioVenta);
  if (!productoId || Number.isNaN(precio) || precio <= 0) {
    throw new Error('Precio de venta inválido');
  }

  await productosService.actualizar(productoId, {
    precio_venta: precio,
    precio,
    requiere_precio: false,
    listas_precios: {
      mayorista: precio,
      interior: precio,
      posadas: precio
    }
  });

  let stockFinal = 0;
  if (cargarStock && sucursalId) {
    const qty = Math.max(0, parseInt(cantidadStock, 10) || 0);
    await stockSucursalService.actualizarStock(sucursalId, productoId, qty, orgId);
    stockFinal = qty;
  } else if (sucursalId) {
    const rows = await stockSucursalService.obtenerStockPorProducto(productoId, orgId).catch(() => []);
    const row = (Array.isArray(rows) ? rows : []).find((r) => r.sucursal_id === sucursalId);
    stockFinal = parseInt(row?.cantidad ?? 0, 10) || 0;
  }

  const refreshed = await productosService.obtenerPorId(productoId);
  return {
    ...refreshed,
    precio_venta: precio,
    requiere_precio: false,
    stock_sucursal: stockFinal,
    stock_actual: stockFinal,
    sucursal_id: sucursalId || refreshed?.sucursal_id
  };
}
